import { render } from "./InstagramFormInput.vue?vue&type=template&id=3601fe5a&scoped=true&ts=true"
import script from "./InstagramFormInput.vue?vue&type=script&lang=ts"
export * from "./InstagramFormInput.vue?vue&type=script&lang=ts"

import "./InstagramFormInput.vue?vue&type=style&index=0&id=3601fe5a&scoped=true&lang=css"

import exportComponent from "/home/kuradmin/frontend-siputra/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3601fe5a"]])

export default __exports__